import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "timesheet-header" }
const _hoisted_2 = { class: "section-heading" }
const _hoisted_3 = { class: "options" }
const _hoisted_4 = { class: "select" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("option", { value: "1" }, "Day", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("option", { value: "2" }, "Week", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("option", { value: "3" }, "Month", -1)
const _hoisted_8 = [
  _hoisted_5,
  _hoisted_6,
  _hoisted_7
]
const _hoisted_9 = { class: "month-selection" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("i", {
  class: "fal fa-angle-left",
  title: "Previous month"
}, null, -1)
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("i", {
  class: "fal fa-angle-right",
  title: "Next month"
}, null, -1)
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = { class: "month-label ml-3" }
const _hoisted_15 = { class: "right-btn" }
const _hoisted_16 = {
  key: 0,
  class: "fal fa-angle-up"
}
const _hoisted_17 = {
  key: 1,
  class: "fal fa-angle-down"
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("button", { class: "btn btn-primary mr-2" }, "Export", -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("hr", { class: "seperator" }, null, -1)
const _hoisted_20 = { class: "filter" }
const _hoisted_21 = { class: "form-col" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("label", null, "Practice name", -1)
const _hoisted_23 = { class: "sml-select" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("option", { value: null }, "All", -1)
const _hoisted_25 = ["value"]
const _hoisted_26 = { class: "form-col" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("label", null, "Activity type", -1)
const _hoisted_28 = { class: "sml-select" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("option", { value: null }, "All", -1)
const _hoisted_30 = ["value"]
const _hoisted_31 = { class: "form-col" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("label", null, "Investigator", -1)
const _hoisted_33 = { class: "sml-select" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("option", { value: null }, "All", -1)
const _hoisted_35 = ["value"]
const _hoisted_36 = { class: "form-col" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("label", null, "Supervisor", -1)
const _hoisted_38 = { class: "sml-select" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("option", { value: null }, "All", -1)
const _hoisted_40 = ["value"]
const _hoisted_41 = { class: "form-col" }
const _hoisted_42 = {
  key: 0,
  class: "reset-filter"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h2", null, _toDisplayString(_ctx.headerTitle), 1),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _withDirectives(_createElementVNode("select", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.calendarView) = $event))
          }, _hoisted_8, 512), [
            [_vModelSelect, _ctx.calendarView]
          ])
        ]),
        _createElementVNode("button", {
          class: "btn btn-default ml-2 today-btn",
          onClick: _cache[1] || (_cache[1] = $event => (_ctx.today()))
        }, " Today "),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("button", {
            class: "btn-no-border",
            onClick: _cache[2] || (_cache[2] = $event => (_ctx.prev()))
          }, _hoisted_11),
          _createElementVNode("button", {
            class: "btn-no-border",
            onClick: _cache[3] || (_cache[3] = $event => (_ctx.next()))
          }, _hoisted_13),
          _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.currentDateDisplay), 1)
        ]),
        _createElementVNode("div", _hoisted_15, [
          (_ctx.showAdvFilterButton)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "btn btn-default mr-2",
                onClick: _cache[4] || (_cache[4] = (...args) => (_ctx.showHideAdvFilter && _ctx.showHideAdvFilter(...args)))
              }, [
                _createElementVNode("span", null, [
                  _createTextVNode("Advanced Filter "),
                  (_ctx.showAdvFilter)
                    ? (_openBlock(), _createElementBlock("i", _hoisted_16))
                    : (_openBlock(), _createElementBlock("i", _hoisted_17))
                ])
              ]))
            : _createCommentVNode("", true),
          _hoisted_18,
          _createElementVNode("button", {
            class: "btn btn-primary mr-2",
            onClick: _cache[5] || (_cache[5] = (...args) => (_ctx.showAddEventModal && _ctx.showAddEventModal(...args)))
          }, " Add time ")
        ])
      ]),
      (_ctx.showAdvFilter)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _hoisted_19,
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("div", _hoisted_21, [
                _hoisted_22,
                _createElementVNode("div", _hoisted_23, [
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => ((_ctx.advanceFilter.practiceName) = $event))
                  }, [
                    _hoisted_24,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.practices, (i) => {
                      return (_openBlock(), _createElementBlock("option", {
                        value: i.name
                      }, _toDisplayString(i.name), 9, _hoisted_25))
                    }), 256))
                  ], 512), [
                    [_vModelSelect, _ctx.advanceFilter.practiceName]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_26, [
                _hoisted_27,
                _createElementVNode("div", _hoisted_28, [
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => ((_ctx.advanceFilter.timeEntryActivityId) = $event))
                  }, [
                    _hoisted_29,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.activityType, (i) => {
                      return (_openBlock(), _createElementBlock("option", {
                        value: i.id
                      }, _toDisplayString(i.name), 9, _hoisted_30))
                    }), 256))
                  ], 512), [
                    [_vModelSelect, _ctx.advanceFilter.timeEntryActivityId]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_31, [
                _hoisted_32,
                _createElementVNode("div", _hoisted_33, [
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => ((_ctx.advanceFilter.trustTeamMemberId) = $event))
                  }, [
                    _hoisted_34,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.investigators, (i) => {
                      return (_openBlock(), _createElementBlock("option", {
                        value: i.id
                      }, _toDisplayString(i.displayName), 9, _hoisted_35))
                    }), 256))
                  ], 512), [
                    [_vModelSelect, _ctx.advanceFilter.trustTeamMemberId]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_36, [
                _hoisted_37,
                _createElementVNode("div", _hoisted_38, [
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => ((_ctx.advanceFilter.supervisorId) = $event))
                  }, [
                    _hoisted_39,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.supervisors, (i) => {
                      return (_openBlock(), _createElementBlock("option", {
                        value: i.id
                      }, _toDisplayString(i.displayName), 9, _hoisted_40))
                    }), 256))
                  ], 512), [
                    [_vModelSelect, _ctx.advanceFilter.supervisorId]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_41, [
                _createElementVNode("button", {
                  class: "btn btn-secondary sml",
                  onClick: _cache[10] || (_cache[10] = $event => (_ctx.applyFilter()))
                }, " Apply filter ")
              ])
            ]),
            (_ctx.filterApplied)
              ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                  _createTextVNode(" Or "),
                  _createElementVNode("a", {
                    class: "link2",
                    onClick: _cache[11] || (_cache[11] = $event => {_ctx.resetFilter();})
                  }, "reset all")
                ]))
              : _createCommentVNode("", true)
          ], 64))
        : _createCommentVNode("", true)
    ])
  ]))
}